<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="deda"><span aria-label="page 3" id="page_3" role="doc-pagebreak"><i>To Casper and Chico.</i></span></p>
<p class="ded"><i>Thanks for being so smart and funny.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?52f309c4